import Siema from "siema";

class Sliders {
  constructor() {
    document.addEventListener("DOMContentLoaded", this.init.bind(this));
  }

  init() {
    if (document.querySelector(".frontshop")) {
      this.initFrontshops();
    }
    if (document.querySelector(".promo__slider")) {
      this.initPromo();
    }
    if (document.querySelector(".gallery")) {
      this.initGalleries();
    }
  }
  initFrontshops() {
    this.frontshops = [...document.querySelectorAll(".frontshop")].map(
      frontshop => {
        const container = frontshop.querySelector(
          ".frontshop__slider .frontshop__wrapper"
        );
        const prev = frontshop.querySelector(".slidernav__prev");
        const next = frontshop.querySelector(".slidernav__next");
        const slider = new Siema({
          selector: container,
          perPage: {
            320: 2,
            480: 3,
            660: 4,
            892: 5,
            1024: 4,
            1128: 5,
            1288: 6,
            1448: 7,
            1608: 8,
            1768: 9
          }
        });
        prev.addEventListener("click", () => slider.prev());
        next.addEventListener("click", () => slider.next());
        return slider;
      }
    );
  }
  initPromo() {
    const container = document.querySelector(".promo__slider .promo__wrapper");
    const prev = document.querySelector(".promo__head .slidernav__prev");
    const next = document.querySelector(".promo__head .slidernav__next");
    const slider = new Siema({
      selector: container,
      perPage: {
        320: 1,
        480: 2,
        1024: 2.2,
        1448: 3.2
      }
    });
    prev.addEventListener("click", () => slider.prev());
    next.addEventListener("click", () => slider.next());
    this.promo = slider;
  }
  initGalleries() {
    this.galleries = [...document.querySelectorAll(".gallery")].map(gallery => {
      const container = gallery.querySelector(".gallery__items");
      const prev = gallery.querySelector(".slidernav__prev");
      const next = gallery.querySelector(".slidernav__next");
      const slider = new Siema({
        selector: container,
        perPage: {
          320: 1,
          480: 2,
          1024: 2.2,
          1448: 3.2
        }
      });
      prev.addEventListener("click", () => slider.prev());
      next.addEventListener("click", () => slider.next());
      return slider;
    });
  }
}

export default Sliders;



// WEBPACK FOOTER //
// ./src/js/apps/sliders.js